module.exports = __webpack_public_path__ + "img/paypal-logo.78037fdb.svg";